import { useMutation } from "@tanstack/react-query";
import { useSetRecoilState } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import { useNavigate } from "react-router-dom";
import { trackCapiStandardEvent } from "analytics/metaCapi";
import { PATH } from "routes/paths";
import { useState } from "react";
import {
  axiosInstanceV3,
  CustomResponseFormat,
  setBearerTokenV3,
} from "./axiosInstanceV3";
import useGtagConversion from "../../../hooks/useGtagConversion";

type SocialType = "google" | "apple";

interface LoginVars {
  idToken: string;
  email?: string;
}

export default function useLoginV3Mutation(type: SocialType) {
  const navigate = useNavigate();
  const setUser = useSetRecoilState(userSimpleAtom);
  const trackGtagEvent = useGtagConversion();

  const [error, setError] = useState<string>();

  const mutation = useMutation({
    mutationFn: async ({ idToken, email }: LoginVars) => {
      const response = await axiosInstanceV3.post<CustomResponseFormat>(
        `/user/v2/login`,
        {
          idToken,
          type,
          ...(email && { email }),
        }
      );
      return response;
    },
    onSuccess: (response) => {
      if (response.code === 0) {
        const result: any = response.result;
        setBearerTokenV3(result.accessToken);
        setUser(result);

        // Meta CAPI
        trackCapiStandardEvent(
          "CompleteRegistration",
          {
            externalId: result.userId,
            email: result.email,
          },
          undefined,
          "v3"
        );

        // Google Ads
        trackGtagEvent("CompleteRegistration", "v3");

        // Navigate next
        if (result.nickname) {
          navigate(PATH.v3Payment, { replace: true });
        } else {
          navigate(PATH.v3NicknameSubmit, { replace: true });
        }
      } else {
        setError(`로그인에 실패했습니다. 다시 시도해주세요.: ${response.code}`);
      }
    },
    onError: (e: any) => {
      console.error("Promotion login failed:", e);
      setError(`로그인에 실패했습니다. 다시 시도해주세요.`);
    },
  });

  return {
    login: mutation.mutate,
    loginAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    error,
  };
}
